import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=204c214d&scoped=true"
import script from "./ItemsList.vue?vue&type=script&lang=js"
export * from "./ItemsList.vue?vue&type=script&lang=js"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=204c214d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c214d",
  null
  
)

export default component.exports